module.exports = __webpack_public_path__ + "img/32-image-1@2x.2565ede2.png";